<template>
  <b-card class="w-100 pt-0 pb-0 border-0">
    <div class="row">
      <div class="col-md-7 col-12 border-right pe-3">
        <div>
          <img
            :src="signedUrl"
            class="card-img-top rounded mb-4"
            alt="Card image cap"
            @error="
              (e) =>
                (e.target.src = require('@/assets/images/img-placeholder.png'))
            "
          />
        </div>
        <div class="d-flex justify-content-between">
          <div>
            <p class="store-name text-capitalize">{{ businessDetails.storeName }}</p>
          </div>
          <div>
            <favorite-item :status="businessDetails.favoritesStatus" @click="addRemoveFavoritesListing" />
          </div>
        </div>
        <p class="m-0 ts-14 mb-2">
          <i class="bx bx-store me-1"></i> {{ businessDetails.businessType }}
        </p>
        <p class="m-0 ts-14 mb-2">
          <i class="bx bx-calendar me-1"></i> Upto {{ businessDetails.duration }} months
        </p>
        <p class="m-0 ts-14 mb-2">
          <i class="bx bx-map me-1"></i> {{ businessDetails.fullAddress }}
        </p>
        <hr />
        <div class="ts-14">
          Nearby Landmark: {{ landmarks }}<br />
        </div>
        <hr />
        <div>
          <p class="ts-12 fw-700 mb-1">Store Location:</p>
          <p class="ts-12 fw-400">Exact location provided after booking</p>
          <div v-if="true">
            <gmap-map
              :options="mapOptions"
              :center="{lat:businessDetails.latitude, lng:businessDetails.longitude}"
              style="width: 100%; height: 200px"
            >
              <gmap-custom-marker :marker="{lat:businessDetails.latitude, lng:businessDetails.longitude}">
                <img class="map-marker" src="@/assets/images/map_marker.png" />
              </gmap-custom-marker>
            </gmap-map>
          </div>
          
          <div class="g-0 text-center" v-else>
            <div class="no-coordinate-box d-flex align-items-center justify-content-center">
              <span>No store coordinates</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-5 col-12 ps-3">
        <p class="ts-12 fw-700">Rental Space:</p>
        <vue-easy-lightbox
          escDisabled
          moveDisabled
          :visible="visibleSpaceImg"
          :index="imgIndex"
          :imgs="spacesSignedUrl"
          @hide="visibleSpaceImg = false"
        ></vue-easy-lightbox>
        <template
          v-for="(space, index) in businessDetails.listings"
        >
          <div
            v-if="space.status == 'available'"
            class="item-div mb-3"
            :key="index"
            >
            <div
              class="d-flex"
            > 
              <div>
                <rental-space-img
                  :imgSrc="spacesSignedUrl[index]"
                ></rental-space-img>
              </div>
              <div class="ps-3 w-100">
                <div class="ts-14 text-capitalize fw-700 mb-1">{{ space.type }}</div>
                <div class="ts-12 fw-400 mb-1">Size: {{ space.dimension }}</div>
                <div class="ts-12 fw-400 mb-1">Placement: {{ space.placement }}</div>
                <div  class="ts-12 fw-400 mb-1">Available for {{ space.duration }} month{{ space.duration > 1 ? "s" : "" }}</div>
                <div  class="ts-12 fw-400 mb-1">Price: ₱ {{ space.amount | toCurrency }}/Month</div>
                <div class="fw-600 ts-12 d-flex justify-content-between mb-3">
                  <div>Sub Total:</div>
                  <div class="text-right">₱ {{ (space.amount * space.duration).toLocaleString('en-US') }}</div>
                </div>
                <div v-if="space.status == 'available'" >
                  <b-button v-if="!postIds.includes(space.postId)" variant="primary" @click="addItemToCart(space)">Add to Checkout</b-button>
                  <b-button v-if="postIds.includes(space.postId)" variant="outline-primary" @click="removeItemFromCart(space)">Remove from Checkout</b-button>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!---end of sub listing-->
        <div class="pt-2 d-flex justify-content-between ts-14 fw-700">
          <div>Total</div>
          <div>₱ {{total | toCurrency}}</div>
        </div>
        <!--end of total-->
        <hr />
        <div class="pt-2 d-flex justify-content-between ts-16 fw-700">
          <div>For Holding</div>
          <div class="green">₱ {{total | toCurrency}}</div>
        </div>
        <div class="pt-3">
          <button
            type="button"
            class="btn btn-primary btn-block w-100 mb-3"
            @click="checkoutForm"
          >
            Place Order
          </button>
          <div class="d-flex align-items-center justify-content-center">
            <span class="float-start me-2 ts-30 order-info-icon">
              <i class="bx bx-info-circle"></i>
            </span>
            <span class="ts-10">
              We will temporarily hold your ₱ {{total | toCurrency}} wallet balance. Once your
              order is submitted, you are unable to use this balance for other
              spaces
            </span>
          </div>
        </div>
        <!--end of total-->
      </div>
      <!-- end of rental space-->
    </div>
  </b-card>
  
</template>

<script>
import {
  listingComputed,
  listingMethods,
  showFeatureUnavailable,
  checkoutMethods, 
  checkoutComputed
} from "@/state/helpers";
import { Storage } from "aws-amplify";
import FavoriteItem from '@/components/widgets/favorite-item.vue';
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import RentalSpaceImg from '@/views/pages/listings/rental-space-img';

export default {
  props: ["value"],
  components: {
    FavoriteItem,
    RentalSpaceImg,
    'gmap-custom-marker': GmapCustomMarker,
  },
  data() {
    return {
      mapOptions: {
        zoom: 15,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        minZoom: 1,
        maxZoom: 15
      },
      cart: [],
      selectedSpaces: [],
      forHoldingAmount: 0,
      visibleSpaceImg: false,
      imgIndex: 0,
    };
  },
  computed: {
    ...listingComputed,
    ...checkoutComputed,
    landmarks: {
      get(){
        if(this.businessDetails.landmark){
          return this.businessDetails.landmark.split(',').filter(str => str).join(', ');
        } else {
          return null;
        }
      }
    },
    postIds: {
      get(){
        var addedItem = [];
        try {
          for(let i of this.checkoutItems){
            for(let x of i.listings){
              addedItem.push(x.post_id);
            }
          } 
        } catch (error) {
         console.log("postIds ERR:",error); 
        }
        return addedItem;
        // return this.cart.map(c => c.postId);
      }
    },
    total: {
      get(){
        var amount = 0;
        try {
          for(let l of this.businessDetails.listings){
            if(this.postIds.includes(l.postId)){
              amount += l.amount * l.duration
            }
          }
        } catch (error) {
         console.log("total computation ERR:",error); 
        }
        return amount;
        // var total = 0;

        // if(this.cart.length > 0){
        //   total = this.cart.map(c => c.amount * c.duration).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        // }
       
        // return total.toLocaleString('en-US');
      }
    }
  },
  asyncComputed: {
    async signedUrl() {
      return this.businessDetails.storePhoto;
    },
    async spacesSignedUrl() {

      // console.log('this.value.listings: ', this.value.listings)

      var keys = this.businessDetails.listings.map((s) => {
          return {
            photo_space: s.photo_space,
            coordinate_x1: s.coordinate_x1,
            coordinate_x2: s.coordinate_x2,
            coordinate_y1: s.coordinate_y1,
            coordinate_y2: s.coordinate_y2
          }
        }),
        signed = [];

      // console.log("hey spacesSignedUrl", keys);
      for (let k of keys) {
        // signed.push(await Storage.get(k, { level: "public" }));
        signed.push({
          url: await Storage.get(k.photo_space, { level: "public" }),
          coordinate_x1: k.coordinate_x1,
          coordinate_x2: k.coordinate_x2,
          coordinate_y1: k.coordinate_y1,
          coordinate_y2: k.coordinate_y2
        })
      }

      // console.log("signUrls:", signed);
      return signed;
    },
  },
  methods: {
    ...listingMethods,
    ...showFeatureUnavailable,
    ...checkoutMethods,
    addItemToCart(listing){
      this.cart.push(listing);
      console.log(this.cart);
      this.addToCart({
        removeItems:[],
        addItems:[listing.postId]
      }).then((res)=>{
        console.log("res",JSON.stringify(res));
        this.fetchCheckoutItems();
      });
    },
    removeItemFromCart(listing){
      for(var i = 0; i < this.cart.length; i++){
        if(listing.postId == this.cart[i].postId){
          this.cart.splice(i, 1);
        }
      }
      this.addToCart({
        removeItems:[listing.postId],
        addItems:[]
      }).then((res)=>{
        console.log("res",JSON.stringify(res));
        this.fetchCheckoutItems();
      });
    },
    async addRemoveFavoritesListing() {
      // eslint-disable-next-line no-unused-vars
      // this.value.favoritesStatus = !this.value.favoritesStatus;
      console.log(this.businessDetails);
      if(!this.businessDetails.favoritesStatus)
      {
         this.addToFavoriteListings({listingId: this.businessDetails.listId, bizId: this.businessDetails.business_id}).then(response => {
            this.$toast.showToast('success', 'Success!', 'Store has been added to favorites.');
            this.businessDetails.favoritesStatus = 1;
            console.log(response);
          })
          // eslint-disable-next-line no-unused-vars
          .catch(error => {
            console.log("addToFavoriteListings err: ", error);
          })
        
      }
      else {
        this.removeToFavoriteListings({bizId: this.businessDetails.business_id}).then(response => {
          this.$toast.showToast('success', 'Success!', 'Store has been removed from favorites.');
          this.businessDetails.favoritesStatus = 0;
          console.log(response);
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          console.log("addToFavoriteListings err: ", error);
        })
      }
    },
    checkoutForm(){
      this.$router.push(
        this.$route.query.redirectFrom || {
          name: "confirm-order", params: {}
        }
      )
    }
  },
  async mounted() {
    await this.fetchCheckoutItems();
    console.log("this.businessDetails.favoritesStatus: ", this.businessDetails.favoritesStatus);
  },
};
</script>

<style scoped>
.card-img-top {
  width: 100%;
  height: 15hv;
  object-fit: contain;
}
.border-right {
  border-right: 1px solid #efefef;
}
.store-name {
  font-family: "Poppins";
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0.03em;
  text-align: left;
}
.btn-minus {
  border: 1px solid #efefef;
  background: #efefef;
}
.item-count {
  border: 1px solid #9999;
  margin: 0px 7%;
  width: 30%;
}
.item-total {
  position: absolute;
  bottom: 0;
  right: 15%;
}
.item-div {
  border-bottom: 1px solid #efefef;
  padding-bottom: 10px;
}
.blank {
  display: none;
}
.btn-fav {
  border: 1px solid #e6eaf1;
  background: #e6eaf1;
  border-radius: 100%;
}

@media (max-width: 600px) {
  .item-total {
    position: relative;
  }
}
.swal2-confirm {
  width: inherit;
}
.swal2-actions {
  width: 80%;
}
.login-btn {
  width: inherit;
}
.modal-actions {
  width: 90%;
}

.no-coordinate-box {
  width: 100%;
  height: 100px;
  border-radius: 8px;
  opacity: 0.25;
  border: solid 1px #adb5bd;
}

.space-preview {
  width: 112px;
  height: 112px;
  object-fit: cover;
}

.green {
  color: #508f30;
}

.order-info-icon {
  color: #3366CC
}

.map-marker {
  border: solid 30px rgba(248, 75, 4, 0.2);
  border-radius: 50%;
  position: relative;
  top: 30px
}
</style>